import BaseDB from 'libs/DB/BaseDB'

const deleteDB = window.indexedDB.deleteDatabase('emailDetailDB')
deleteDB.onerror = (error) => {
  console.log('error - db delete failed', error)
}
deleteDB.onblocked = (event) => {
  // 구버전 코드가 열어 둔 연결이 남아 있으면 삭제가 대기 상태로 남는다. 해당 탭이 닫히면 자동으로 완료된다.
  console.warn('warning - db delete blocked.', event)
}

const dataDB = new BaseDB('emailDetailDB2', {
  version: 1,
  key: 'id',
  expireDuration: 30 * 24 * 60 * 60 * 1000, // 만료 기간 30일.
  skipPreload: true,
})

export default dataDB
